import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import {
  ChevronUp,
  PlusCircle,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../core/redux/action";
import Table from "../../core/pagination/datatable";
import Axios from "axios";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { API_BASE_URL, GET_POS_TERMINALS } from "../../Config";
import SpinLoader from "../loader/SpinLoader";
import AddPosTerminal from "./AddPosTerminal";
import EditPosTerminal from "./EditPosTerminal";
import Swal from "sweetalert2";

const PosTerminal = () => {
  const [userDataSession, setUserDataSession] = useState({});
  const [terminalData, setTerminalData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedTerminal, setSelectedTerminal] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, [navigate]);

  // Fetch POS Terminals
  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_POS_TERMINALS}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data.Status && response.data.ResultData) {
            setTerminalData(response.data.ResultData);
          } else {
            console.error(
              "Error fetching terminals:",
              response.data.Message || "No data"
            );
            setTerminalData([]);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching terminals:", error);
          setTerminalData([]);
          setLoading(false);
        });
    }
  }, [userDataSession]);

  // Search filtering - works on StoreName, Name (Terminal), Description
  const filteredData = terminalData.filter(
    (item) =>
      item &&
      ((item.StoreName &&
        item.StoreName.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.Name &&
          item.Name.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.Description &&
          item.Description.toLowerCase().includes(searchQuery.toLowerCase())))
  );

  const handleSelectedTerminal = (terminal) => {
    setSelectedTerminal(terminal);
  };
  // Table Columns for POS Terminals
  const columns = [
    {
      title: "S.No",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Store",
      dataIndex: "StoreName",
      sorter: (a, b) => a.StoreName.localeCompare(b.StoreName),
    },
    {
      title: "Terminal Name",
      dataIndex: "Name",
      sorter: (a, b) => a.Name.localeCompare(b.Name),
    },
    {
      title: "Description",
      dataIndex: "Description",
      sorter: (a, b) => a.Description.localeCompare(b.Description),
    },
    {
      title: "Terminal Type",
      dataIndex: "TerminalType",
      sorter: (a, b) => a.TerminalType.localeCompare(b.TerminalType),
    },
    {
      title: "Actions",
      render: (text, record) => (
        <td className="action-table-data">
          <div className="edit-delete-action">
            {/* Example Edit Link - replace with your offcanvas/modal */}
            <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasTerminalEdit"
              onClick={() => handleSelectedTerminal(record)}
            >
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            {/* Delete can be added later */}
            <Link
              className="confirm-text p-2"
              onClick={() => deleteTerminal(record.Id)}
            >
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
          </div>
        </td>
      ),
    },
  ];

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="collapse-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  // Excel Export
  const handleDownloadExcel = () => {
    if (terminalData.length === 0) return;

    const wsData = terminalData.map((item, index) => ({
      "S.No": index + 1,
      Store: item.StoreName,
      "Terminal Name": item.Name,
      Description: item.Description,
      "Terminal Type": item.TerminalType,
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Terminals");
    XLSX.writeFile(wb, "POS_Terminals.xlsx");
  };

  // PDF Export
  const generatePDF = () => {
    const doc = new jsPDF();
    const headers = [
      ["S.No", "Store", "Terminal Name", "Description", "Terminal Type"],
    ];
    const rows = terminalData.map((item, index) => [
      index + 1,
      item.StoreName,
      item.Name,
      item.Description || "",
      item.TerminalType,
    ]);

    doc.autoTable({
      head: headers,
      body: rows,
    });
    doc.save("POS_Terminals.pdf");
  };

  const deleteTerminal = (terminalId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Axios.post(`${API_BASE_URL}Settings/DelPosTerminals`, {
          Id: terminalId,
          OrgId: userDataSession.OrgId,
        })
          .then((response) => {
            if (response.data.Status) {
              Swal.fire(
                "Deleted!",
                "The terminal has been deleted.",
                "success"
              );
              // Refresh terminal list
              setTerminalData((prevData) =>
                prevData.filter((item) => item.Id !== terminalId)
              );
            } else {
              Swal.fire(
                "Error!",
                response.data.Message || "Failed to delete terminal.",
                "error"
              );
            }
          })
          .catch((error) => {
            console.error("Error deleting terminal:", error);
            Swal.fire(
              "Error!",
              "Something went wrong. Please try again.",
              "error"
            );
          });
      }
    });
    // Implement delete functionality here
  };
  selectedTerminal &&
    console.log(selectedTerminal, "selected terminal in list");
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>POS Terminals</h4>
              <h6>Manage your POS terminals</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li onClick={generatePDF}>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="pdf" />
                </Link>
              </OverlayTrigger>
            </li>
            <li onClick={handleDownloadExcel}>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link>
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="excel"
                  />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => dispatch(setToogleHeader(!data))}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <Link
              to="#"
              className="btn btn-added"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasTerminalAdd"
            >
              <PlusCircle className="me-2" />
              Add
            </Link>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="input-group search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <span className="input-group-text bg-white">
                    <i data-feather="search" className="feather-search"></i>
                  </span>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              {loading ? (
                <SpinLoader />
              ) : (
                <Table columns={columns} dataSource={filteredData} />
              )}
            </div>
          </div>
        </div>
      </div>
      <AddPosTerminal />
     <EditPosTerminal terminal={selectedTerminal} />
    </div>
  );
};

export default PosTerminal;
